module.exports = __webpack_public_path__ + "static/media/diamond-strike.4b688664.gif";